export var trimInputString = function trimInputString(value) {
  return (value === null || value === void 0 ? void 0 : value.toString().trim()) || '';
};